import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {WishlistPageService_GetWishlistHeaderBannerLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.grpc.lazy';
import {useOptionalSession} from '@aboutyou/user';
import {useTargetGroupIdentifier} from '../../../../../shared-deprecated/useTargetGroupIdentifier';

export const useWishlistHeaderBanner = () => {
  const session = useOptionalSession();
  const targetGroup = useTargetGroupIdentifier();
  return useGrpcRequest(WishlistPageService_GetWishlistHeaderBannerLazy, {
    session,
    targetGroup,
  });
};
